"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.vesselSearchEngine = exports.searchableVesselFields = void 0;
const search_engine_1 = require("./search-engine");
function generateCountDescFunc(prescript) {
    return (count, term, representative) => {
        const isETASearch = prescript.toLowerCase().includes('eta');
        const value = isETASearch ? `${Number(term) / (3600 * 24)} days` : term;
        return representative
            ? `Vessels ${prescript}`
            : `${count} vessel${count > 1 ? 's' : ''} ${prescript} ${value}`;
    };
}
const VESSEL_CARGO_MAPPING = {
    L: 'LADEN',
    B: 'BALLAST',
};
exports.searchableVesselFields = {
    imo: {
        command: 'imo',
        commandDescription: 'Enter a vessel IMO number',
        searchConfig: {
            searchPriority: 1,
            searchFieldDescription: 'IMO',
            indexTransformer: undefined,
        },
        countDescFunc: generateCountDescFunc('with IMO'),
    },
    secondsToNextPort: {
        command: 'eta',
        commandDescription: 'Use the slider for estimated time to next port',
        searchConfig: {
            searchPriority: 1,
            searchFieldDescription: 'ETA',
            indexTransformer: undefined,
            numericRangeSearch: '<',
        },
        countDescFunc: generateCountDescFunc('with ETA before'),
    },
    speed: {
        command: null,
        commandDescription: null,
        countDescFunc: generateCountDescFunc('with speed'),
    },
    nextPortName: {
        command: 'nextport',
        commandDescription: 'Enter a port name to select vessels by their next port',
        searchConfig: {
            searchPriority: 2,
            searchFieldDescription: 'Next Port Name',
            indexTransformer: undefined,
        },
        countDescFunc: generateCountDescFunc('going to port'),
    },
    arrival: {
        command: null,
        commandDescription: null,
        countDescFunc: generateCountDescFunc('arriving at'),
    },
    source: {
        command: null,
        commandDescription: 'Enter a data source',
        countDescFunc: generateCountDescFunc('with data retrieved from'),
    },
    lastPortName: {
        command: 'lastport',
        commandDescription: '',
        searchConfig: {
            searchPriority: 3,
            searchFieldDescription: 'Last Port Name',
            indexTransformer: (value) => value,
        },
        countDescFunc: generateCountDescFunc('leaving from port'),
    },
    departure: {
        command: null,
        commandDescription: null,
        countDescFunc: generateCountDescFunc('departed at'),
    },
    flag: {
        command: 'flag',
        commandDescription: 'Enter the name of a flag state',
        searchConfig: {
            searchPriority: 6,
            searchFieldDescription: 'Flag',
            indexTransformer: (value) => value,
        },
        countDescFunc: generateCountDescFunc('with flag state'),
    },
    picLabel: {
        command: 'pic',
        commandDescription: 'Enter the email address of a person-in-charge',
        searchConfig: {
            searchPriority: 7,
            searchFieldDescription: 'In-Charge',
            indexTransformer: (value) => value,
        },
        countDescFunc: generateCountDescFunc('with in-charge'),
    },
    course: {
        command: null,
        commandDescription: null,
        countDescFunc: generateCountDescFunc('with Course'),
    },
    owner: {
        command: 'owner',
        commandDescription: 'Enter the name of a vessel owner',
        searchConfig: {
            searchPriority: 3,
            searchFieldDescription: 'Vessel Owner',
            indexTransformer: undefined,
        },
        countDescFunc: generateCountDescFunc('owned by'),
    },
    manager: {
        command: 'manager',
        commandDescription: 'Enter the name of a vessel manager',
        searchConfig: {
            searchPriority: 3,
            searchFieldDescription: 'Vessel Manager',
            indexTransformer: undefined,
        },
        countDescFunc: generateCountDescFunc('managed by'),
    },
    updatedAt: {
        command: null,
        commandDescription: null,
        countDescFunc: generateCountDescFunc('updated at'),
    },
    portCallsLastChanged: {
        command: null,
        commandDescription: null,
        countDescFunc: generateCountDescFunc('had portcalls last changed at'),
    },
    status: {
        command: null,
        commandDescription: 'Enter an AIS status',
        searchConfig: {
            searchPriority: 6,
            searchFieldDescription: 'Status',
            indexTransformer: (value) => value,
        },
        countDescFunc: generateCountDescFunc('with AIS status'),
    },
    operatingStatus: {
        command: null,
        commandDescription: 'Enter an operating status',
        searchConfig: {
            searchPriority: 6,
            searchFieldDescription: 'Operating Status',
            indexTransformer: (value) => value,
        },
        countDescFunc: generateCountDescFunc('with Operating status'),
    },
    type: {
        command: 'type',
        commandDescription: 'Enter a vessel type',
        searchConfig: {
            searchPriority: 7,
            searchFieldDescription: 'Type',
            indexTransformer: (value) => value,
        },
        countDescFunc: generateCountDescFunc('of type'),
    },
    nextPortCode: {
        command: 'nextportcode',
        commandDescription: 'Enter the LOCODE of the next port',
        searchConfig: {
            searchPriority: 2,
            searchFieldDescription: 'Next Port LOCODE',
            indexTransformer: undefined,
        },
        countDescFunc: generateCountDescFunc('going to LOCODE'),
        searchType: 'prefix',
    },
    lastPortCode: {
        command: 'lastportcode',
        commandDescription: 'Enter the LOCODE of the most recent port',
        searchConfig: {
            searchPriority: 3,
            searchFieldDescription: 'Last Port LOCODE',
            indexTransformer: (value) => value,
        },
        countDescFunc: generateCountDescFunc('leaving from LOCODE'),
        searchType: 'prefix',
    },
    dwt: {
        command: null,
        commandDescription: null,
        countDescFunc: generateCountDescFunc('with tonnage'),
    },
    mmsi: {
        command: 'mmsi',
        commandDescription: 'Enter an MMSI',
        searchConfig: {
            searchPriority: 10,
            searchFieldDescription: 'MMSI',
            indexTransformer: undefined,
        },
        countDescFunc: generateCountDescFunc('with MMSI'),
    },
    addedBy: {
        command: null,
        commandDescription: 'Enter the email address of the person who entered the data',
        countDescFunc: generateCountDescFunc('created by'),
    },
    id: {
        command: null,
        commandDescription: null,
        countDescFunc: generateCountDescFunc('with ID'),
    },
    name: {
        command: 'name',
        commandDescription: 'Enter a vessel name',
        searchConfig: {
            searchPriority: 0,
            searchFieldDescription: 'Name',
            indexTransformer: undefined,
        },
        countDescFunc: generateCountDescFunc('named'),
    },
    cargoStatus: {
        command: 'cargostatus',
        commandDescription: 'Enter either Laden or Ballast',
        searchConfig: {
            searchPriority: 1,
            searchFieldDescription: 'Cargo Status',
            indexTransformer: (value) => VESSEL_CARGO_MAPPING[value] || null,
        },
        countDescFunc: generateCountDescFunc('with Cargo Status'),
    },
    lat: {
        command: null,
        commandDescription: null,
        countDescFunc: generateCountDescFunc('with Latitude'),
    },
    lng: {
        command: null,
        commandDescription: null,
        countDescFunc: generateCountDescFunc('with Longitude'),
    },
    riskStatus: {
        command: null,
        commandDescription: null,
        countDescFunc: generateCountDescFunc('with Risk Status'),
    },
    riskStatusColor: {
        command: null,
        commandDescription: null,
        countDescFunc: generateCountDescFunc('with risk color'),
    },
    CRY4GeneratedUUID: {
        command: null,
        commandDescription: null,
        countDescFunc: generateCountDescFunc('with CRY4 ID'),
    },
    image: {
        command: null,
        commandDescription: null,
        countDescFunc: generateCountDescFunc('with Image URL'),
    },
    crewHomeAirports: {
        command: null,
        commandDescription: null,
        searchConfig: {
            searchPriority: 4,
            searchFieldDescription: 'Crew Home Airports',
            indexTransformer: (airports) => (airports &&
                Object.keys(airports).map((iataCode) => { var _a; return (_a = airports[iataCode].airport) === null || _a === void 0 ? void 0 : _a.text; })) ||
                [],
        },
        countDescFunc: generateCountDescFunc('with crew going to/from'),
    },
    crewNationalities: {
        command: null,
        commandDescription: null,
        searchConfig: {
            searchPriority: 5,
            searchFieldDescription: 'Crew Home Airports',
            indexTransformer: (nationalities) => (nationalities &&
                Object.keys(nationalities).map((countryCode) => nationalities[countryCode].country.text)) ||
                [],
        },
        countDescFunc: generateCountDescFunc('with Crew from'),
    },
    routeExists: {
        command: null,
        commandDescription: null,
        countDescFunc: generateCountDescFunc('with route status'),
    },
    upcomingCrewChangeEvents: {
        command: 'eventeta',
        commandDescription: 'Use the slider for Crew Change Event ETA',
        searchConfig: {
            searchPriority: 1,
            searchFieldDescription: 'Crew Change Event ETA',
            indexTransformer: (upcomingCrewChangeEvents) => upcomingCrewChangeEvents
                .filter((e) => !!e.eta)
                .map((e) => {
                try {
                    return (new Date(e.eta).getTime() - new Date().getTime()) / 1000;
                }
                catch (err) {
                    console.error(`Error converting '${e.eta}' to numeric val`, err);
                    return null;
                }
            })
                .filter((v) => !!v),
            numericRangeSearch: '<',
        },
        countDescFunc: generateCountDescFunc('with Crew Change Events ETA within'),
    },
    vesselTags: {
        command: 'tags',
        commandDescription: 'Enter a vessel tag',
        searchConfig: {
            searchPriority: 1,
            searchFieldDescription: 'Tag',
            indexTransformer: (vesselTags) => vesselTags.map(({ displayName }) => displayName),
        },
        countDescFunc: generateCountDescFunc('with tag'),
    },
};
exports.vesselSearchEngine = new search_engine_1.SearchEngine({
    idField: 'id',
    fields: exports.searchableVesselFields,
});
